import CredentialModal from './CredentialModal'
export default CredentialModal